import { deleteCookie, setCookie } from 'cookies-next'

import { isValidLocale } from '@/lib/config/i18n/local'
import { getSharedCookieDomain, isLocalDev } from '@/lib/utils/cookie-domain'

export const LOCALE_COOKIE_KEY = 'NEXT_LOCALE'

/** 一年（秒） */
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

/**
 * 把 locale 写入 Cookie（digen.ai 子域共享；Amplify / localhost 为 host-only）
 */
export const writeLocaleCookie = (locale: string): void => {
  if (!isValidLocale(locale)) return
  const domain = getSharedCookieDomain()
  setCookie(LOCALE_COOKIE_KEY, locale, {
    maxAge: ONE_YEAR_SECONDS,
    path: '/',
    sameSite: 'lax',
    secure: !isLocalDev(),
    ...(domain ? { domain } : {})
  })
}

/**
 * 清理当前 host 上 host-only 的 NEXT_LOCALE（无 Domain 属性那一份）。
 *
 * 背景：旧版 next-intl 在 `localeCookie: true` 阶段会写入 host-only 的
 * NEXT_LOCALE，与我们现在写入的 Domain=.digen.ai 的 NEXT_LOCALE 共存，
 * 浏览器会把两份同名 Cookie 同时发送，服务端读取顺序不可控。
 *
 * 这里只发一条不带 Domain 的失效 Set-Cookie：浏览器仅匹配 host-only
 * 那一份执行删除，Domain=.digen.ai 的不受影响。本地开发不清理。
 */
export const cleanupHostOnlyLocaleCookie = (): void => {
  if (typeof window === 'undefined' || isLocalDev()) return
  deleteCookie(LOCALE_COOKIE_KEY, { path: '/' })
}
